import React, { useContext, useState } from 'react'
import { UserContext } from 'stores/UserStore'
import report from 'api/report'
import log from 'api/log'
import {useTranslation} from "react-i18next";
// import { toast } from 'react-toastify'

export const SmartContext = React.createContext({})

export const SmartProvider = ({ children }) => {
  const { idToken } = useContext(UserContext)
  const [isLoading, setLoading] = useState(false)
  const [tableData, setTableData] = useState([])
  const [ data, setData ] = useState([])
  const [applications, setApplications] = useState([])

  const getReportData = () => {
    setLoading(true)
    report
      .getReportData(idToken, 'init')
      .then((data) => {
        data = data.body ? data.body : data
        setTableData(data.tableData)
        setLoading(false)
      })
      .catch((error) => {
        console.debug(error)
      })
  }

  const searchData = (params) => {
    setLoading(true)
    report
      .searchData(idToken, params)
      .then((data) => {
        data = data.body ? data.body : data
        setTableData(data.tableData)
        setLoading(false)
      })
      .catch((error) => {
        console.debug(error)
      })
  }

  const getCustomerData = () => {
    setLoading(true)
    report
      .getCustomerSuccess(idToken, 'init')
      .then((data) => {
        data = data.body ? data.body : data
        setTableData(data.tableData)
        setLoading(false)
      })
      .catch((error) => {
        console.debug(error)
      })
  }

  const searchCustomerData = (params) => {
    setLoading(true)
    report
      .searchCustomerSuccess(idToken, params)
      .then((data) => {
        data = data.body ? data.body : data
        setTableData(data.tableData)
        setLoading(false)
      })
      .catch((error) => {
        console.debug(error)
      })
  }

  const searchDataManagement = (params) => {
    setLoading(true)
    report
      .searchDataManagement(idToken, params)
      .then((data) => {
        data = data.body ? data.body : data
        setData(data)
        setLoading(false)
      })
      .catch((error) => {
        console.debug(error)
      })
  }
  const getLogData = () => {
    setLoading(true)
    log
        .getLogData(idToken, 'init')
        .then((data) => {
            data = data.body ? data.body : data
            setTableData(data.tableData)

            const items = [];
            for (const app of data.applications) {
                items.push({label: app.label, value: app.id})
            }
            setApplications(items)
            setLoading(false)
        })
        .catch((error) => {
            console.debug(error)
        })
}

const searchLogData = (params) => {
    setLoading(true)
    log
        .searchLogData(idToken, params)
        .then((data) => {
            data = data.body ? data.body : data
            setTableData(data.tableData)
            setLoading(false)
        })
        .catch((error) => {
            console.debug(error)
        })
}

  return (
    <SmartContext.Provider
      value={{
        tableData,
        getReportData,
        getCustomerData,
        searchCustomerData,
        searchDataManagement,
        searchData,
        getLogData,
        searchLogData,
        isLoading,
        data
      }}
    >
      {children}
    </SmartContext.Provider>
  )
}